import React from "react";
import SurfaceCard from "../../../Components/Common/SurfaceCard";
import OverviewChart from "../../../../components/Overview/OverviewChart";

function SalesChartCard({ chartsData, currencyLabel, dateRange, loading }) {
  return (
    <div className="col-12 col-xl-6">
      <SurfaceCard className="sales-chart-card">
        <div className="sales-chart-card__header">
          <h3>Sales ({currencyLabel})</h3>
        </div>

        {loading ? (
          <div className="sales-chart-card__skeleton">
            <div className="sales-chart-card__skeleton-bar" />
            <div className="sales-chart-card__skeleton-chart" />
          </div>
        ) : (
          <div className="sales-chart-card__body">
            <OverviewChart chartsData={chartsData || []} dates={dateRange} />
          </div>
        )}
      </SurfaceCard>
    </div>
  );
}

export default function SalesChartSection({
  chartData = {},
  dateRange,
  loading = false,
}) {
  return (
    <div className="row g-4">
      <SalesChartCard
        chartsData={chartData.USD}
        currencyLabel="USD"
        dateRange={dateRange}
        loading={loading}
      />
      <SalesChartCard
        chartsData={chartData.LBP}
        currencyLabel="LBP"
        dateRange={dateRange}
        loading={loading}
      />
    </div>
  );
}
